// GLOBAL API
const url = process.env.REACT_APP_API_URL || '/api'

// UNCOMMENT Line:4 when running on local environment
// const url = `http://${window.location.hostname}:5000`

export default url  
